import xss from 'xss'
import anchorme from 'anchorme'
import DOMPurify from 'dompurify'
import { whiteList as defaultCssWhiteList } from 'cssfilter'

const LINK_ATTRIBUTES = [
  { name: 'target', value: 'blank' },
  { name: 'class', value: 'text-hyper-link' },
  { name: 'rel', value: 'noopener noreferrer' },
]

const LINK_TAG_ATTRIBUTES = ['href', 'class', 'target', 'rel']

export const richTextXssOptions = () => ({
  whiteList: {
    i: [],
    u: [],
    b: [],
    em: [],
    br: [],
    ul: [],
    ol: [],
    li: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    sup: [],
    sub: [],
    strong: [],
    p: ['class'],
    span: ['class', 'style', 'contenteditable', 'data-latex'],
    svg: ['width', 'height', 'viewBox', 'preserveAspectRatio'],
    path: ['d'],
    line: ['x1', 'y1', 'x2', 'y2', 'stroke-width'],
  },
  css: {
    whiteList: {
      ...defaultCssWhiteList,
      position: '/^relative$/',
      top: true,
      bottom: true,
      left: true,
      'vertical-align': true,
    },
  },
})

// anchorme 1.x (CVE-2021-23411) has no fixed release and can emit attacker-controlled markup, so its output is always re-sanitised.
export const autoLinkSanitized = (html, xssOptions = richTextXssOptions()) => {
  const options = {
    ...xssOptions,
    whiteList: { ...xssOptions.whiteList, a: LINK_TAG_ATTRIBUTES },
  }
  return xss(anchorme(html, { attributes: LINK_ATTRIBUTES }), options)
}

// The freestyle editor stores raw TinyMCE innerHTML (any tag, style or data-mce-* attribute), so a fixed tag whitelist would rewrite saved decks; DOMPurify keeps all inert markup.
export const autoLinkEditorHtml = (html) => DOMPurify.sanitize(
  anchorme(html, { attributes: LINK_ATTRIBUTES }),
  { ADD_ATTR: ['target'] },
)
